export enum ConfirmStatus {
  success = <any>'success',
  invalid = <any>'invalid',
  expired = <any>'expired',
  used = <any>'used',
  wrongUser = <any>'wrongUser',
  login = <any>'login',
  resend = <any>'resend'
}
